/**
 * @author：
 * @update：
 * @description：
 **/
import {dictionaryList} from '../../api/url'
export default {
    data() {
        return {
            searchCon:'',//查询内容
            bol:false
        };
    },
    // 自定义方法
    methods: {
        dataList(){
            let data = {
                name:this.searchCon,
                pageNumber:1,
                pageSize:99999
            };
            this.$ajax.get(dictionaryList,data).then(res=>{
                console.log(res);

            },err=>{
                console.log(err);
            })
        }
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        this.dataList();
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
